/**
 * The one error both push channels throw when the user has not allowed
 * notifications. Lives apart from pushClient so the native bridge
 * (native/push.js) can throw it without importing pushClient back (a cycle).
 */
export class PushPermissionError extends Error {
  constructor(permission) {
    super(`Push permission was not granted: ${permission}`);
    this.name = "PushPermissionError";
    this.permission = permission;
  }
}
